// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"828bdd8c","191":"a5e3cfc6","327":"56b062aa","811":"c0936d61"}[chunkId] + ".chunk.css";
};